function getDefineConf() {
    return {
        // ApprovalState.state
        approvalState: {
            PENDING: 1, //  대기
            PARTIALLY_APPROVED: 2, // 부분 승인
            APPROVED: 3, // 승인 완료
            REJECTED: 4, // 승인 거절
            WITHDRAWN: 5, // 승인 철회
            CANCELLED: 6, // 승인 취소
        },

        // ApprovalDetail.state
        approvalDetailState: {
            PENDING: 0, //  대기
            APPROVED: 1, // 승인 완료
            REJECTED: 2, // 승인 거절
            CANCELLED: 3, // 승인 취소
        },

        // MomSysInspection.inspectionType
        inspectionType: {
            INPUT_INSPECTION: 1, // 입고 검사
            SELF_INSPECTION: 2, // 자주 검사
            OUTSOURCING_INPUT_INSPECTION: 3, // 외주 입고 검사
            CUSTOMER_SUPPLY_INPUT_INSPECTION: 4, // 사급 입고 검사
        },

        // MomSysInspection.qcResult
        qcResult: {
            QC_OK: 0,
            QC_NOK: 1,
        },

        // TkOutSourcingPurchase.outSourcingStatus
        outSourcingStatus: {
            NOT_SHIP: 0,
            PARTIAL_SHIP_COMPLETE: 1,
            SHIP_COMPLETE: 2,
            PARTIAL_INPUT_COMPLETE: 3,
            INPUT_COMPLETE: 4,
        },

        // TkOutSourcingShip.outSourcingShipState
        outSourcingShipState: {
            NOT_SHIP: 0,
            SHIP_COMPLETE: 1,
        },

        // MomSysSgtWipLot.outSourcing
        outSourcing: {
            NON_OUTSOURCED: 0,
            OUTSOURCED: 1,
        },

        // TkPopProductManage.produceStatus
        produceStatus: {
            UNWORKED: 0,
            WORKING: 1,
            HOLDING: 2,
            COMPLETION: 3,
            ACQUIRED: 4,
        },

        // Mrp Event Type
        mrpEventType: {
            CONSUME: 1,
            PRODUCTION: 2,
            INPUT_BY_PURCHASE: 3,
        },

        // materialTypeCode
        materialTypeCode: {
            완제품: 10,
            FINISHED_PRODUCT: 10,

            반제품: 20,
            HALF_FINISHED_PRODUCT: 20,

            원자재: 30,
            RAW_MATERIAL: 30,

            재공품: 40,
            WIP_PRODUCT: 40, // Work In Process

            상품: 50,
            GOODS: 50,

            부자재: 60,
            SUBSIDIARY_MATERIAL: 60,
        },

        // OP codeInfo
        opCode: {
            PUR: "PUR",
            PUR2: "PUR2",
            REP: "REP",
            REP2: "REP2",
            PST: "PST",
            WCM: "WCM",
        },

        //MomSysStockTakingMst.stockTakingType
        stockTakingType: {
            ALL: 0, // 전체 재고 조사
            PRODUCT: 1, // 제품 재고 조사
            MATERIAL: 2, // 자재 재고 조사
        },

        // Cut Code1
        cutCode1: {
            CUSTOMER_SUPPLY_MATERIAL: "소재사급",
            SELF_SUPPLY_MATERIAL: "소재도급",
        },

        //CompanyBranchType
        branchType: {
            office: 0,
            factory: 1,
        },

        // tkDeliveryState
        deliveryState: {
            NOT_DELIVERY: 0,
            PARTIAL_DELIVERY: 1,
            COMPLETE_DELIVERY: 2,
        },
        // tkDeliveryDetailState
        deliveryDetailState: {
            NOT_DELIVERY: 0,
            COMPLETE_DELIVERY: 1,
            WAIT_DELIVERY: 2,
        },

        // TkPartnerPriceAgreement.agreementType
        agreementType: {
            ORDER_PURCHASE_PRICE_AGREEMENT: 1, // 일반 발주
            OUTSOURCING_PRICE_AGREEMENT: 2, // 외주 발주
            ELECTRODE_PURCHASE_PRICE_AGREEMENT: 3, // 전극소재 발주
        },

        // TkVWPriceAgreement.partnerType
        partnerType: {
            ORDER_PURCHASE_PARTNER: 1,
            OUTSOURCING_PARTNER: 2,
            ELECTRODE_PURCHASE_PARTNER: 3,
        },

        // TkVWPriceAgreement.xxxAgreementCompleted
        agreementRslt: {
            AGREEMENT_NONE: 0,
            AGREEMENT_COMPLETED: 1,
            AGREEMENT_DENIED: 2,
            AGREEMENT_CANCELED: 3,
        },

        // tkTestResults
        testResults: {
            FIT: 0,
            PART_FIT: 1,
            UNFIT: 2,
        },

        // MomSysZvwOrderBuyerDetail
        delivered: {
            NO: 0,
            YES: 1,
            WATING: 2,
        },

        // TkPartnerPriceAgreement : confirmType
        priceAgreementConfirmType: {
            OUR_CONFIRM: 1,
            PARTNER_CONFIRM: 2,
        },

        // TwPopWire.sizeType, TkProcessFactorCost
        sizeType: {
            BIG: "대형",
            SMALL: "소형",
            COMMON: "공통",
        },

        // TkPopGrinding.material , grindingSideQty
        grindingMaterial: {
            BASIC: "일반재질",
            SPECIAL: "특수재질",
        },

        grindingSideQty: {
            TSIDE: "T면연마",
            FOURSIDE: "4면연마",
            SIXSIDE: "6면연마",
        },

        // TkPopProductManage.buttonFilterIndex
        buttonFilterIndex: {
            TODAY: "today",
            TOMORROW: "tomorrow",
            UNWORKED: "unworked",
            WORKING: "working",
            POPALL: null,
        },

        // TkTotalAmountCalculation.factor
        totalAmountFactor: {
            PROCESS: "process",
            TIME: "time",
            REPAIR: "repair",
            SELECT: "select",
        },

        // TkTotalAmountCalculation.wraapingSpec
        wrappingSpec: {
            lowUnitPrice: "#1500",
            mediumUnitPrice: "#3000",
            highUnitPrice: "#8000",
        },

        // TkTotalAmountCalculation.agreementState
        agreementState: {
            AGREEMENT_NONE: 0,
            AGREEMENT_COMPLETED: 1,
            AGREEMENT_DENIED: 2,
            AGREEMENT_CANCELED: 3,
        },

        // TkPopProductManage.wpSpec
        wpSpec: {
            lowUnitPrice: "#1500",
            mediumUnitPrice: "#3000",
            highUnitPrice: "#8000",
        },

        //MomSysBomBopFileDetail       
        bomBopRegistrationStatus: {
            failure: 0,
            success: 1,
            duplicated: 2,
            notApplicable: 3
        },

        // ItemUnitName
        itemUnitName: {
            MM: 'mm',
            CM: 'cm',
            M: 'm',
            KM: 'km',
            MG: 'mg',
            G: 'g',
            KG: 'kg',
            TON: 'ton',
            ML: 'ml',
            DL: 'dl',
            L: 'L',
            BOX: 'box',
            EA: 'ea',
            ROLL: 'roll'
        }
    };
}

const defineConf = getDefineConf();

module.exports = defineConf;
